import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompensationGridObject } from '@it2go/types';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { map } from 'rxjs/operators';
import {
    selectCurrentService,
    selectPerson,
} from '../../../store/person/person.selectors';
import { PersonService } from 'packages/client/src/app/services/person.service';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { diagnosesFrag } from './voucher-detail-general.query';

interface State {
    compensations: CompensationGridObject | null;
}

const defaultState: State = {
    compensations: null,
};

@Injectable()
export class VoucherDetailGeneralStore extends ComponentStoreFactory<
    State,
    PersonService
> {

    private readonly svc = inject(PersonService);
    person$ = this.globalStore!.select(selectPerson);
    serviceExpertise$ = this.globalStore!.select(selectCurrentService).pipe(
        map((it) => it?.expertise?.code || 0),
    );
    public compensations$ = this.svc.getCompensations(FilterBuilder.singlePage({ sort: {column: 'description'} }));

    public getDiagnosis(code: string) {
        return this.svc.getDiagnoses(new FilterBuilder().search(code).filter(), diagnosesFrag);
    }

    constructor() {
        super(defaultState, inject(Store), inject(PersonService));
    }
}
